import { pageRoutes } from 'constants/routing'
import QueryString from 'qs'
import { getProviderProfileParams } from 'utils/common'

export const PROVIDERS = '/providers'
export const PRACTITIONER_PROFILE = '/providers/profile'
export const PRACTICES = '/practices'
export const PROVIDER_FILTERS = `${PROVIDERS}/filters`
export const COMMON_SPECIALITIES = `${PROVIDERS}/common-specialities`
export const GET_SLOTS = '/slots/get'
export const ALL_PROVIDER_DETAILS = 'providers/details'
export const MICROLINK_BASE_URL = 'https://api.microlink.io'
export const GEO_TIMEZONE_URL = '/geo-timezone'
export const FIND_PROVIDERS_BY_NAME = '/providers/search'
export const BUSINESS_PARTNERS = '/business-partners'
export const PROVIDER_SLOTS = '/slots/first-available-slot'
export const FILTERS_BY_TYPE = `${PROVIDERS}/filters/type`
export const FILTERS_BY_TYPE_AND_STATE = `${PROVIDERS}/filters-by-type-state`
export const REFERRAL_TREATMENT_TYPES = '/referral/internal-treatment-types'

export const getFiltersByTypeAndStateRoute = (
  type: string,
  stateCode: string
): string =>
  `${FILTERS_BY_TYPE_AND_STATE}?${QueryString.stringify({ type, stateCode })}`

export const getGeoTimezone = (latitude: string, longitude: string): string =>
  `${GEO_TIMEZONE_URL}${QueryString.stringify(
    { latitude, longitude },
    { addQueryPrefix: true }
  )}`

export const getAMDToken = (practiceId: string): string => {
  return `/states-meta/amd-pay-public-key/practice/${practiceId}`
}

export const getProviderAvailability = (
  providerId: string,
  queryObj: Record<string, string>
): string => {
  const queryString = QueryString.stringify(queryObj, {
    addQueryPrefix: true,
  })
  return `/providers/${providerId}/availability${queryString}`
}

export const getProviderRoute = (
  queryObject: ProviderProfileQueryParams
): string => {
  const queryParams = QueryString.stringify(queryObject, {
    addQueryPrefix: true,
  })
  return `${PRACTITIONER_PROFILE}${queryParams}`
}

export const getProviderForPracticeRoute = (id: string): string =>
  `${PROVIDERS}?practiceId=${id}`

export const getReferringProvidersSearchRoute = (
  searchTerm: string,
  userId: string
): string => `providers/referring/search/${searchTerm}?userId=${userId}`

export const getReferringProvidersEhrIdRoute = (
  providerId: string,
  practiceId: string,
  userId: string
): string =>
  `providers/${providerId}/practices/${practiceId}/referring-provider-ehr-id?userId=${userId}`

export const getProviderProfileRoute = (
  provider: Provider,
  practice?: Practice
): string => {
  /*
    Handle both slug based as well as practiceId based provider profile urls
    TODO: Need to update this to return only slug based provider profile url once
    corresponding backend changes are done
  */

  const params:
    | SlugBasedProfileParams
    | PracticeIdBasedProfileParams = getProviderProfileParams(
    provider,
    practice
  )
  let providerProfileRoute

  if ('slug' in params) {
    const { type, state, slug } = params
    const formattedState = state.toLowerCase()
    providerProfileRoute = `/${type}/${formattedState}/${slug}`
  } else {
    const { providerName, providerId, practiceId, city, state } = params
    providerProfileRoute = `${pageRoutes.PROVIDER_PROFILE}/${state}/${city}/${providerName}/${providerId}/${practiceId}`
  }

  const formattedProviderProfileRoute = providerProfileRoute
    .replace(/\s/g, '-')
    .toLowerCase()
  return formattedProviderProfileRoute
}

export const validateB2BPartnerCodeRoute = (
  enteredKeyword: string,
  selectedBusinessPartnerName: string
): string =>
  `/business-partners/validate-code-by-name?code=${enteredKeyword}&partnerName=${selectedBusinessPartnerName}`

export const buildB2bDetailsByKeywordUrl = (partnershipCode: string): string =>
  `/business-partners/partnershipCode/${partnershipCode}`

export const fetchAllBusinessPartnersRoute = (
  offset: number,
  limit: number
): string => {
  return `${BUSINESS_PARTNERS}?offset=${offset}&limit=${limit}`
}

export const getProviderTestimonialsRoute = (
  providerId: string,
  offset: number,
  limit: number
): string =>
  `${PROVIDERS}/${providerId}/testimonials?offset=${offset}&limit=${limit}`
